// extracted by mini-css-extract-plugin
module.exports = {"inputField":"forms_inputField__iURby","inputLabel":"forms_inputLabel__P_L9j","errorMsg":"forms_errorMsg__LXtlU","gitInput":"forms_gitInput__g_g23"};